var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04688 7.62593L10.8092 5.00537",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8092 13.0209L6.04688 10.4004",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1904 6.42079C14.6873 6.42079 15.9008 5.2073 15.9008 3.71039C15.9008 2.21348 14.6873 1 13.1904 1C11.6935 1 10.48 2.21348 10.48 3.71039C10.48 5.2073 11.6935 6.42079 13.1904 6.42079Z",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1904 17.0001C14.6873 17.0001 15.9008 15.7866 15.9008 14.2897C15.9008 12.7928 14.6873 11.5793 13.1904 11.5793C11.6935 11.5793 10.48 12.7928 10.48 14.2897C10.48 15.7866 11.6935 17.0001 13.1904 17.0001Z",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71039 11.7111C5.2073 11.7111 6.42079 10.4976 6.42079 9.00068C6.42079 7.50377 5.2073 6.29028 3.71039 6.29028C2.21348 6.29028 1 7.50377 1 9.00068C1 10.4976 2.21348 11.7111 3.71039 11.7111Z",
    stroke: "#2A5A16",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.619b1a8daf490ed94c258d3154f768c2.svg";
export { ForwardRef as ReactComponent };